import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';

const CustomStyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    padding: theme.spacing(2.5, 3), // top-bottom, left-right
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3.5, 4), // top-bottom, left-right
  },
  pb: {
    xs: theme.spacing(10), // bottom padding for xs
    sm: theme.spacing(10), // bottom padding for sm
  },
}));

const NoCards = ({ onAddCard }) => {
  return (
    <CustomStyledBox>
      <Typography variant="h3" mb={3}>Payment Methods</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onAddCard}
        >
          <AddIcon htmlColor="white" />
          Add a Card
        </Button>
      </Box>

    </CustomStyledBox>
  );
};

NoCards.propTypes = {
  onAddCard: PropTypes.func.isRequired,
};

export default NoCards;
